import { useMemo } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
// import FilterBar from "../../lib/components/Filterbar/Filterbar";
import LogManager from "./LogManager";
import { useGlobalFilters } from "../../lib/context/GlobalFilterProvider";
import ChargerDisplay from "../../lib/components/ChargerDisplay";

export default function LogsDownload({ embedded = true }) {
  const { serialNumber } = useGlobalFilters();

  const LogManagerContent = useMemo(() => LogManager, []);

  return (
    <div className={embedded ? "w-full overflow-visible" : "w-full h-screen overflow-scroll p-8"}>
      {!embedded && <h1 className="text-2xl font-bold mb-2">Troubleshoot</h1>}
      {!embedded && <ChargerDisplay serialNumber={serialNumber} showSidePanel={false} />}
      <Box>{LogManagerContent && <LogManagerContent serialNumber={serialNumber} />}</Box>
    </div>
  );
}

LogsDownload.propTypes = {
  embedded: PropTypes.bool,
};
